import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UploadedFile, FileService } from '@app/services/file.service';

@Component({
  selector: 'app-edit',
  templateUrl: './edit.component.html',
  styleUrls: ['./edit.component.scss'],
  standalone: false
})
export class DocumentEditComponent implements OnInit {

  file: UploadedFile;
  title: string;
  newFile: File;
  uploadingNewFile = false;

  @ViewChild('fileInput') fileInput: any;

  constructor(
    @Inject(MAT_DIALOG_DATA) private data,
    private fileService: FileService
  ) { }

  ngOnInit() {
    this.file = this.data.file || {};
    this.title = this.file.name;
  }

  onFileSelected(event: any) {
    const files = event.target.files;
    if (files && files.length > 0) {
      this.newFile = files[0];
      this.file.name = this.newFile.name;
    }
  }

  clearFileSelection() {
    this.newFile = null;
    if (this.fileInput) {
      this.fileInput.nativeElement.value = '';
      this.file.name = this.title;
    }
  }
}
